import { handleAuthModalLoaded, handleNoAuthHtmxResponse } from "./handlers/auth";

import { attachCsrfToken, rotateCsrfToken } from "./handlers/csrf";

import { handleResponseError } from "./handlers/errors";

import { handleNetworkError } from "./handlers/network";

import { clearAlertHistory } from "./handlers/alertHistory";

export function initHTMX() {
  if (window.__htmx_initialized__) return;

  window.__htmx_initialized__ = true;

  // ---------------------------------------------------------------------------
  // CONFIG
  // ---------------------------------------------------------------------------

  htmx.config.refreshOnHistoryMiss = true;

  htmx.config.historyCacheSize = 25;

  htmx.config.historyRestoreAsHxRequest = false;

  // ---------------------------------------------------------------------------
  // ERRORS
  // ---------------------------------------------------------------------------

  document.body.addEventListener("htmx:responseError", handleResponseError);

  // ---------------------------------------------------------------------------
  // NETWORK
  // ---------------------------------------------------------------------------

  document.body.addEventListener("htmx:timeout", handleNetworkError);

  document.body.addEventListener("htmx:sendError", handleNetworkError);

  // ---------------------------------------------------------------------------
  // CSRF
  // ---------------------------------------------------------------------------

  document.body.addEventListener("htmx:configRequest", attachCsrfToken);

  document.body.addEventListener("htmx:afterRequest", rotateCsrfToken);

  // ---------------------------------------------------------------------------
  // AUTH
  // ---------------------------------------------------------------------------

  document.body.addEventListener("htmx:beforeSwap", handleNoAuthHtmxResponse);

  document.body.addEventListener("htmx:afterRequest", handleAuthModalLoaded);

  // ---------------------------------------------------------------------------
  // ALERT HISTORY
  // ---------------------------------------------------------------------------

  document.body.addEventListener("htmx:beforeHistorySave", clearAlertHistory);
}
